import { MEMBER_POOL_STORAGE_EDIT_REQUEST, MEMBER_POOL_STORAGE_EDIT_SUCCESS, MEMBER_POOL_STORAGE_EDIT_FAILURE } from './types/MemberPoolStorageEditActionsTypes';

export function putMemberPoolStorageEditRequestActionCreator(operatorCode,
  palletCount,
  trayCount) {
  return {
    type: MEMBER_POOL_STORAGE_EDIT_REQUEST,
    payload: {
      params: {
        operator: operatorCode,
        palletCapacity: palletCount,
        trayCapacity: trayCount,
      },
    },
  };
}

export function putMemberPoolStorageEditSuccessActionCreator(data) {
  return {
    type: MEMBER_POOL_STORAGE_EDIT_SUCCESS,
    payload: data,
  };
}

export function putMemberPoolStorageEditFailureActionCreator(error) {
  return {
    type: MEMBER_POOL_STORAGE_EDIT_FAILURE,
    payload: error,
    error: true,
  };
}
